import { Injector } from '@angular/core';
import { ButtonActionType, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';
import { onCancelCard, refreshCardsAndRedirect } from '../card-management-v2/cancel-card-actions.utils';
import { getSecureCardDetails } from '../card-management-v2/get-sensitive-details.utils';
import { shareCvvDetails } from '../card-management-v2/secure-cvv-details.utils';
import { onSetCardName } from '../card-management-v2/set-card-name.utils';
import { showEPINUtil, showPINUtil } from '../card-management-v2/show-epin.utils';
import { functionCtaType } from '../cta-button-actions.utils';
import { addCard } from '../card-management-v2/add-card.utils';
import { onActivateCard } from '../card-management-v2/activate-card.utils';

export const cardManagementActions: Map<ButtonActionType, functionCtaType> = new Map([
  [
    ButtonActionType.SECURE_CVV_DETAILS,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      shareCvvDetails(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.CANCEL_CARD,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      onCancelCard(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.SET_CARD_NAME,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      onSetCardName(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.SHOW_PIN,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      showPINUtil(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.SHOW_EPIN,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      showEPINUtil(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.REFRESH_CARDS_AND_REDIRECT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      refreshCardsAndRedirect(injector, attri);
    },
  ],
  [
    ButtonActionType.GET_SENSITIVE_CARD_DETAILS,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      getSecureCardDetails(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.ADD_CARD,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      addCard(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.ACTIVATE_CARD,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      onActivateCard(injector, attri.widgetProperties);
    },
  ],
]);
